module.exports = __webpack_public_path__ + "img/close-gray.cded3d8f.svg";